"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAGE_AGE_MS = void 0;
exports.createPetState = createPetState;
exports.deriveStage = deriveStage;
exports.ageMsAt = ageMsAt;
const types_1 = require("./types");
const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
/** Age at which the pet enters each stage. Growth is the only thing time still does. */
exports.STAGE_AGE_MS = {
    baby: 0,
    child: 6 * HOUR,
    teen: 24 * HOUR,
    adult: 72 * HOUR,
};
function createPetState(bornAtMs) {
    return { bornAt: bornAtMs };
}
/** Life stage for a given age in ms. Stages are ordered oldest-last in {@link LIFE_STAGES}. */
function deriveStage(ageMs) {
    let stage = 'baby';
    for (const candidate of types_1.LIFE_STAGES) {
        if (ageMs >= exports.STAGE_AGE_MS[candidate])
            stage = candidate;
    }
    return stage;
}
function ageMsAt(state, nowMs) {
    return Math.max(0, nowMs - state.bornAt);
}
//# sourceMappingURL=pet.js.map